import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { LogoutService } from 'src/app/service/logout.service';
import { RegisterService } from 'src/app/service/register.service';
import { ResponseStatus } from 'src/enum/responseEnum';
import { CustomSnackbarService } from '../custom-notification/custom-notification.component';
import { HomeService } from 'src/app/service/home.service';
import { PageStateService } from 'src/app/service/page-state.service';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.css']
})
export class SideMenuComponent {
  @Input() public isMobileMenu: boolean = false;
  // @Input() public sideMenuType = "type1";
  showSuccessModal: boolean = false;
  userDetails: any = "";
  popUpType: number = 1;
  menuList: any;
  isMenuTypeSingleList: any;
  sideMenuType: any;

  handleSuccessModal() {
    this.showSuccessModal = !this.showSuccessModal;
  }
  constructor(private router: Router,
    private register: RegisterService,
    private logOut: LogoutService,
    private customSnackbarService: CustomSnackbarService,
    private pageStateService: PageStateService) {
  }

  ngOnInit() {
    this.getUserDetails();

    this.getSideMenu();

  }

  isActive(url: string): boolean {
    return this.router.url === url;
  }

  navigateTo(url: string): void {
    this.pageStateService.resetCurrentPage();
    this.router.navigateByUrl(url);
  }

  getSideMenu() {
    let _menuListStorage = localStorage.getItem("menuList")
    this.menuList = _menuListStorage && JSON.parse(_menuListStorage);


    // let _menuListSort = this.menuList.every((item:any) => item.hasOwnProperty('menuItems') && Array.isArray(item.menuItems))

    // this.sideMenuType = _menuListSort ? "type1" : "type2";


    // console.log(this.menuList,  this.sideMenuType, "this.menuList")

  }


  getUserName() {
    return localStorage.getItem('name') || 'User'
  }


  logoutUser() {
    localStorage.clear();
    this.router.navigateByUrl(`/`);
    this.customSnackbarService.openCustomSnackbar('User logged out successfully.');
    this.logOut.logoutUser().then((res) => {
    }).catch((error) => {
      console.log(error);
    })
  }

  getUserFullName() {
    return this.userDetails.firstName || ""
  }

isAdmin : boolean = false;
  getUserDetails() {
    this.register.fetchUserDetails().then((res) => {
      if (res.status = ResponseStatus.SUCCESS) {
        this.userDetails = res.data.user;
        if(this.userDetails.roleName == 'ADMIN'){
          this.isAdmin = true;
        }else{
          this.isAdmin = false;
        }
      }
    })
  }

  checkUserLogin() {
    if (localStorage.getItem('marieTokenAdmin')) {
      return true;
    }
    else {
      return false;
    }
  }

}
